export default __webpack_public_path__ + "static/media/new_emozioni_primarie.cc7554de.jpeg";